const FLOAT_NUMBER_REGEX = /(([0]{1}|([1-9]\d*))(,\d{0,1})?)/g;
const INT_NUMBER_REGEX = /(\d+)/g;

export function floatNumberFormatter(value: string) {
  const matchedValue = value.replace('.', ',').match(FLOAT_NUMBER_REGEX);

  return matchedValue ? matchedValue[0] : '';
}

export function integerNumberFormatter(value: string) {
  const matchedValue = value.match(INT_NUMBER_REGEX);

  return matchedValue ? matchedValue[0] : '';
}
